import React, { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';

const ActivityLogContext = createContext(null);
const STORAGE_KEY = 'activity-log';

export function ActivityLogProvider({ children }) {
  const loaded = useRef(false);
  const [logs, setLogs] = useState([]);

  // Load from localStorage once
  useEffect(() => {
    if (loaded.current) return;
    loaded.current = true;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setLogs(JSON.parse(raw));
    } catch (_) {}
  }, []);

  // Persist
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(logs.slice(0, 500)));
    } catch (_) {}
  }, [logs]);

  const addEntry = useCallback((entry) => {
    const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    const item = {
      id,
      ts: new Date().toISOString(),
      entity: entry.entity,
      action: entry.action,
      summary: entry.summary,
      meta: entry.meta || {}
    };
    setLogs((prev) => [item, ...prev].slice(0, 500));
  }, []);

  const clear = useCallback(() => setLogs([]), []);

  const value = useMemo(() => ({ logs, addEntry, clear }), [logs, addEntry, clear]);

  return (
    <ActivityLogContext.Provider value={value}>{children}</ActivityLogContext.Provider>
  );
}

export function useActivityLog() {
  const ctx = useContext(ActivityLogContext);
  if (!ctx) throw new Error('useActivityLog must be used within ActivityLogProvider');
  return ctx;
}


